import { configureStore } from '@reduxjs/toolkit';
import i18nReducer from "./slices/i18nSlice";
import applicationReducer from "./slices/ApplicationSlice";

export default configureStore({
  reducer: {
    i18n: i18nReducer,
    application: applicationReducer,
  }
});